export enum PeSignupState {
  SignUp = 'SignUp',
  Manage = 'Manage',
  Pending = 'Pending',
  ReconcileDomain = 'ReconcileDomain',
}

export enum PeSignupType {
  ewx = 'ewx',
  epn = 'epn',
}
